
import React, { useContext } from "react";
import SbEditable from "storyblok-react";
import Button from "src/components/Button";



const ColourPickerCta = ({ blok }) => {

  return (
    <SbEditable content={blok} key={blok._uid}>
      <div className="py-6 flex items-center" style={{ backgroundColor: blok.background_colour.color ? blok.background_colour.color : undefined, }}>
        <div className="max-w-7xl mx-auto px-8">
          <div className="flex lg:flex-shrink-0">
            <div className={`${blok.background_color?.color ? null : "bg-red"} inline-flex shadow`}>
              <Button
                className="uppercase button_color_picker"
                target={blok.button_target.cached_url}
                style={{ color: blok.button_label_colour.color ? blok.button_label_colour.color : undefined,backgroundColor: blok.button_background.color ? blok.button_background.color : undefined,}}
                blank={
                      blok.gated_content
                        ? false
                        : blok.button_target.linktype !== "story"
                        ? true
                        : false
                    }
              >
                {blok.button_label}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </SbEditable>
  );
};

export default ColourPickerCta;
